<template>
	<div class="banner-container">
		<el-carousel height="350px" indicator-position="bottom" autoplay :interval="5000" arrow="hover">
			<el-carousel-item v-for="(item, index) in bannerList" :key="index">
				<el-image :src="item.imgUrl" alt="轮播图" class="banner-img" @click="handleBannerClick(item.link)" />
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
	
	export default {
		name: 'Banner',
		
		props: {
			bannerList: {
				type: Array,
				default: () => []
			},
			
		},
		
		methods: {
			
			/**
			 * 获取广告轮播图
			 */
			async getADBannerList() {
				const temResult = await getBannerList()
				if (temResult.code == 200) {
					this.bannerList = []
					this.bannerList = temResult.data
				}
			},
			
			
			
			
			
			handleBannerClick(link) {
				if (link) this.$router.push(link)
			}
			
			
			
		}
	}
</script>

<style lang="scss" scoped>
	.banner-container {
		width: 100%;

		.banner-img {
			width: 100%;
			height: 100%;
			border-radius: 3px;
			object-fit: cover;
			cursor: pointer;
		}

		::v-deep .el-carousel__indicator-button {
			width: 12px;
			height: 12px;
			border-radius: 50%;
			background-color: rgba(255, 255, 255, 0.6);
		}

		::v-deep .el-carousel__indicator--active .el-carousel__indicator-button {
			background-color: #fff;
		}
	}
</style>